import { useState } from 'react';
import { CheckboxGroup } from '@stitch-fix/mode-react';
import { A } from '@mobily/ts-belt';
import { FilterQueryParam } from '../../../utils/hooks/useSearchParams';
import { FilterFragment } from '../../../utils/hooks/getSearchResults';
import MenuSheet from '../MenuSheet';
import ColorFilter, { ColorOption } from './ColorFilter';
type FilterMenuProps = Pick<FilterFragment, 'label' | 'menuDisplayTemplate' | 'options'> & {
  id: FilterQueryParam;
  initialSelectedValues?: string[];
  onViewResultsClick: (id: FilterQueryParam, selectedValues: string[]) => void;
  onResetClick: () => void;
  isViewResultsDisabled: boolean;
};

/**
 * Used for narrowing down the options type from a union
 * to the specific type expected by ColorFilter.
 */
const isColorFilter = (menuDisplayTemplate: FilterMenuProps['menuDisplayTemplate'], options: FilterMenuProps['options']): options is ColorOption[] => {
  return menuDisplayTemplate === 'MULTI_SELECT_COLOR';
};

/**
 * `FilterMenu` allows clients to select multiple options to narrow down search results.
 */
const FilterMenu = ({
  id,
  initialSelectedValues = [],
  label,
  menuDisplayTemplate,
  onViewResultsClick,
  options,
  isViewResultsDisabled,
  onResetClick
}: FilterMenuProps) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(initialSelectedValues);
  return <MenuSheet label={label} count={initialSelectedValues.length} onClose={() => setSelectedValues(initialSelectedValues)} isViewResultsDisabled={isViewResultsDisabled} onViewResultsClick={() => onViewResultsClick(id, selectedValues)} onResetClick={onResetClick} isResetDisabled={A.isEmpty(selectedValues)}>
      {isColorFilter(menuDisplayTemplate, options) ? <ColorFilter id={id} selectedValues={selectedValues} setSelectedValues={setSelectedValues} options={options} /> : <CheckboxGroup name={id} value={selectedValues} onChange={setSelectedValues} options={options} direction="vertical" />}
    </MenuSheet>;
};
export default FilterMenu;